import cloneDeep from 'lodash/cloneDeep'
import constants from '@/common/constants'
import { ShippingService } from '@/services/api'

export default {
  data() {
    return {
      countries: [],
      countriesSelect: [],
      notificationTypes: [],
      notificationTypesSelect: []
    }
  },
  mixins: [constants],
  methods: {
    isEnded(shipping) {
      return shipping.status === 'DELIVERED' ||
        shipping.status === 'RETURNED' ||
        shipping.status === 'CANCELED'
    },
    // Single source of truth for a shipping's ETA. Mobile OSs throttle background
    // location, so the moover tracking is often stale or missing; when the shipping
    // carries an item/trailer with its own tracker that position is usually fresher.
    // Returns { eta (seconds), etaType ('courier'|'item'), etaUpdateDate } without
    // mutating the shipping — each caller decides how to apply it.
    getShippingEta(shipping) {
      const noEta = { eta: null, etaType: null, etaUpdateDate: null }

      if (shipping?.status !== 'INTRANSIT') return noEta
      if (!shipping.distance || !shipping.duration) return noEta
      if (!shipping.address_to?.lat || !shipping.address_to?.lng) return noEta

      // Courier goes in first so it wins on a timestamp tie (strict > below).
      const candidates = []
      const courierTracking = shipping.courier?.courier_available?.tracking?.[0]
      if (courierTracking?.lat && courierTracking?.lng && courierTracking.created_at) {
        candidates.push({
          lat: courierTracking.lat,
          lng: courierTracking.lng,
          date: courierTracking.created_at,
          type: 'courier'
        })
      }
      const items = shipping.items || []
      items.forEach(item => {
        const itemTracking = item?.item_tracking
        if (itemTracking?.lat && itemTracking?.lng && itemTracking.last_position_updated_at) {
          candidates.push({
            lat: itemTracking.lat,
            lng: itemTracking.lng,
            date: itemTracking.last_position_updated_at,
            type: 'item'
          })
        }
      })

      if (candidates.length === 0) return noEta

      // Both timestamps are fixed-width MySQL DATETIMEs, so lexicographic order
      // matches chronological order. Candidates were filtered above, so we only
      // ever compare a string against another string (no numeric fallbacks).
      const freshest = candidates.reduce((best, candidate) => candidate.date > best.date ? candidate : best, candidates[0])

      const distanceToDestination = this.getDistance(
        { lat: freshest.lat, lng: freshest.lng },
        { lat: shipping.address_to.lat, lng: shipping.address_to.lng }
      )
      const timePerDistanceUnit = shipping.duration / shipping.distance

      return {
        eta: timePerDistanceUnit * (distanceToDestination * 1.2),
        etaType: freshest.type,
        etaUpdateDate: freshest.date
      }
    },
    setItemsToShow(shippings) {
      if (Array.isArray(shippings)) {
        return shippings.map(x => this.doSetItemsToShow(x))
      } else {
        return this.doSetItemsToShow(shippings)
      }
    },
    doSetItemsToShow(x) {
      if (x.items && x.items.length > 0) {
        x.itemsToShow = x.items.map(y => {
          if (y.item) {
            return this.formatItem(y.item)
          } else {
            return this.formatItem(y)
          }
        })
      } else if (x.meta?.items?.length > 0) {
        x.itemsToShow = x.meta.items.map(y => {
          if (y.item) {
            return this.formatItem(y.item)
          } else {
            return this.formatItem(y)
          }
        })
      } else {
        x.itemsToShow = []
      }
      x.itemsQuantity = x.itemsToShow ? x.itemsToShow.reduce((a, b) => a + (Number.parseInt(b.quantity) || 1), 0) : null
      return x
    },
    formatItem(data) {
      return {
        id: data.id || null,
        reference_code: data.reference_code || this.$gettext('No reference code'),
        description: data.description || this.$gettext('No item description'),
        quantity: data.quantity || 1,
        serial_number: data.serial_number && Array.isArray(data.serial_number) && data.serial_number.length > 0 ? data.serial_number.join(', ') : (data.serialNumbers && Array.isArray(data.serialNumbers) && data.serialNumbers.length > 0 ? data.serialNumbers.join(', ') : null),
        original_serial_number: cloneDeep(data.serial_number || null)
      }
    },
    sendToRoutifier(collection, silent = false) {
      if (collection.length > 1) {
        this.start_location = {
          lat: collection[0].address_from.lat,
          lng: collection[0].address_from.lng
        }
        this.routifierCourierCount = 1 // Force ONE courier for send collection to Routifier
        if (this.routifierCouriers.length > 0 || this.routifierCourierCount !== null) {
          if (
            confirm(this.$gettext('Are you sure you want to SEND the current Collection to Routifier?'))
          ) {
            const params = {
              shippings: collection.map(x => x.id),
              start_location: this.start_location,
              scheduled_date: null
            }
            if (this.routifierCourierCount !== null) {
              params.couriersCount = this.routifierCourierCount
            }
            this.$http.post(this.$appConfig.api.baseUrl + 'tours', params).then(response => {
              for (const tour of response.body) {
                window.open('/tours/edit/' + tour.id)
              }
              this.collection = []
              this.routifierCouriers = []
              this.routifierCourierCount = 1
              this.refreshTable()
            }, error => {
              const obj = {
                title: 'ERROR',
                message: error.body.message,
                type: 'error'
              }
              this.$parent.$refs.simplert.openSimplert(obj)
            })
          }
        } else {
          alert('You must set a Couriers Qty. *OR* search and select courier/s by email for the Routifier Collection')
        }
      } else {
        alert('Routifier Collection must contain MORE than 1 shipping')
      }
    },
    formatShippingPopup(shipping) {
      let infoWindowHtml = ''
      const shippingSize = this.shippingSizes.find(x => x.id === shipping.size_id)
      infoWindowHtml += '<p>' + this.$gettextInterpolate(this.$gettext('From: <strong>%{fromAddress}</strong>'), { fromAddress: shipping.from_address || shipping.address_from.formatted_address }) + '</p>'
      infoWindowHtml += '<p>' + this.$gettextInterpolate(this.$gettext('To: <strong>%{toAddress}</strong>'), { toAddress: shipping.to_address || shipping.address_to.formatted_address }) + '</p>'
      infoWindowHtml += shippingSize
        ? '<p>' + this.$gettextInterpolate(this.$gettext('Size: <strong>%{size}</strong>'), { size: shippingSize.name }) + '</p>'
        : ''
      infoWindowHtml += shipping.status_history && shipping.status_history.length > 0
        ? '<p>' + this.$gettextInterpolate(this.$gettext('Current status: <strong>%{status}</strong>'), { status: shipping.status_history[0].status })
        : ''
      infoWindowHtml += shipping.status_history && shipping.status_history.length > 0 && shipping.status_history[0].details?.reason
        ? '<br />' + this.$gettextInterpolate(this.$gettext('Status details: <strong>%{statusDetails}</strong>'), { statusDetails: this.statusReasonsStrings[shipping.status_history[0].details.reason] ? this.statusReasonsStrings[shipping.status_history[0].details.reason] : shipping.status_history[0].details.reason }) + '</p>'
        : ''
      infoWindowHtml += shipping.status_history && shipping.status_history.length > 0
        ? '</p>'
        : ''
      infoWindowHtml += '<p>' + this.$gettextInterpolate(this.$gettext('Last updated: <strong>%{lastUpdated}</strong>'), { lastUpdated: this.moment.utc(shipping.updated_at).tz(this.$tz).format('L LT') }) + '</p>'

      return infoWindowHtml
    },
    checkForAutoExtraCheckpoints(item) {
      let extraCheckpoints = []
      if (item.geo_fences.length > 0) {
        extraCheckpoints = extraCheckpoints.concat(this.checkDistinctExtraPoints(item.geo_fences))
      }
      if (item.geo_lines.length > 0) {
        extraCheckpoints = extraCheckpoints.concat(this.checkDistinctExtraPoints(item.geo_lines))
      }
      if (item.geo_points.length > 0) {
        extraCheckpoints = extraCheckpoints.concat(this.checkDistinctExtraPoints(item.geo_points))
      }
      return extraCheckpoints.filter(Boolean)
    },
    checkDistinctExtraPoints(elements) {
      elements = elements.map(x => {
        if (elements.filter(y => y.geo_type_id === x.geo_type_id).length > 1) {
          x.dupe = true
        } else {
          x.dupe = false
        }
        return x
      })
      return elements
    },
    async assignCollection() {
      this.$store.dispatch('showSpinner')
      const promiseAssignShipments = []
      for (const shipping of this.collection) {
        promiseAssignShipments.push(this.assignShipping(shipping))
      }
      await Promise.all(promiseAssignShipments)
        .then(results => {
          this.forcedBulkAssign = false

          this.applyAssignResults(results)

          this.openAssignFeedback(results, this.$gettext('%{count} shipment/s have been assigned to the courier'))

          this.emitCollectionChanged()
        })
        .finally(() => {
          this.$store.dispatch('hideSpinner')
        })
    },
    async assignShipping(shipping) {
      try {
        if (shipping.status === 'CONFIRMED') {
          await this.$http.post(this.$appConfig.api.baseUrl + 'status', {
            shipping_id: shipping.id,
            status: 'INCIDENCE',
            details: {
              reason: 'other'
            },
            meta: this.$gettext('Bulk reassign courier')
          })
        }
        const response = await this.$http.post(this.$appConfig.api.baseUrl + 'status', {
          shipping_id: shipping.id,
          user_id: this.courier.id,
          status: 'CONFIRMED'
        })
        const detail = await this.$http.get(this.$appConfig.api.baseUrl + 'shippings/' + response.body.shipping_id)
        return { success: true, id: shipping.id, body: detail.body }
      } catch (error) {
        return {
          success: false,
          id: shipping.id,
          error: (error?.body?.message) || this.$gettext('Unknown error')
        }
      }
    },
    async assignCollectionToCarrier() {
      if (!this.carrier || this.assigningCarrier) {
        return
      }
      this.assigningCarrier = true
      try {
        const promiseAssignShipments = []
        for (const shipping of this.collection) {
          promiseAssignShipments.push(this.assignShippingToCarrier(shipping))
        }
        const results = await Promise.all(promiseAssignShipments)

        this.applyAssignResults(results)

        this.openAssignFeedback(results, this.$gettext('%{count} shipment/s have been assigned to the carrier'))

        this.carrier = null
        this.emitCollectionChanged()
      } finally {
        this.assigningCarrier = false
      }
    },
    async assignShippingToCarrier(shipping) {
      try {
        const response = await ShippingService.update(shipping.id, {
          courier_company_id: this.carrier.id
        })
        if (response.success === false) {
          return { success: false, id: shipping.id, error: (response.error?.message) || this.$gettext('Unknown error') }
        }
        const detail = await this.$http.get(this.$appConfig.api.baseUrl + 'shippings/' + shipping.id)
        return { success: true, id: shipping.id, body: detail.body }
      } catch (error) {
        return {
          success: false,
          id: shipping.id,
          error: (error?.body?.message) || this.$gettext('Unknown error')
        }
      }
    },
    applyAssignResults(results) {
      const collection = [...this.collection]
      results.filter(x => x.success).forEach(item => {
        const index = collection.findIndex(x => x.id === item.id)
        if (index !== -1) {
          collection[index] = { ...collection[index], ...item.body }
        }
      })
      this.$store.dispatch('setCollection', collection)
    },
    openAssignFeedback(results, successMessage) {
      const successes = results.filter(x => x.success)
      const errors = results.filter(x => !x.success)

      let obj
      if (errors.length === 0) {
        obj = {
          title: this.$gettext('SUCCESS'),
          message: this.$gettextInterpolate(successMessage, { count: successes.length }),
          type: 'success'
        }
      } else {
        const errorsString = [...new Set(errors.map(x => x.error))]
        const errorsCollection = errorsString.map(message => {
          return {
            message,
            count: errors.filter(y => y.error === message).length,
            ids: errors.filter(y => y.error === message).map(y => y.id).join(',')
          }
        })
        obj = {
          title: this.$gettext('WARNING'),
          message: this.$gettextInterpolate(this.$gettext('%{successCount} of %{totalCount} shipment/s were assigned, but there were %{count} errors to review.<br><br>Error types:<br>%{errorList}'), {
            successCount: successes.length,
            totalCount: results.length,
            count: errors.length,
            errorList: errorsCollection.map(x => { return x.message + '<br>' }).join('')
          }, true),
          type: 'warning'
        }
      }

      this.$root.$children[0].$refs.simplert.openSimplert(obj)
    }
  }
}
